import { useAuth, useUser } from "@clerk/react";
import { usePlans } from "@clerk/react/experimental";
import { useCallback, useMemo } from "react";

import type { FeatureKey } from "~/types/subscription";

export const useResolvedHas = () => {
  const { has } = useAuth();
  const { user } = useUser();
  const { data } = usePlans();

  const metadataPlanSlug = user?.publicMetadata?.plan as string | undefined;

  const planByPublicMetadata = useMemo(() => {
    return metadataPlanSlug
      ? (data.find((plan) => plan.slug === metadataPlanSlug) ?? null)
      : null;
  }, [data, metadataPlanSlug]);

  const hasFeature = useCallback(
    (featureKey: FeatureKey): boolean => {
      if (metadataPlanSlug) {
        return (
          planByPublicMetadata?.features.some(
            (item) => item.slug === featureKey
          ) ?? false
        );
      }

      return has({ feature: featureKey });
    },
    [has, metadataPlanSlug, planByPublicMetadata]
  );

  return { hasFeature, planByPublicMetadata };
};
